var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsExpand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57692 21C3.2583 21 3 20.7417 3 20.4231V14.25C3 13.8358 3.33579 13.5 3.75 13.5C4.16421 13.5 4.5 13.8358 4.5 14.25V19.5H9.75C10.1642 19.5 10.5 19.8358 10.5 20.25C10.5 20.6642 10.1642 21 9.75 21H3.57692Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4231 2.99996C20.7417 2.99996 21 3.25825 21 3.57688V9.74996C21 10.1642 20.6642 10.5 20.25 10.5C19.8358 10.5 19.5 10.1642 19.5 9.74996V4.49996H14.25C13.8358 4.49996 13.5 4.16417 13.5 3.74996C13.5 3.33574 13.8358 2.99996 14.25 2.99996H20.4231Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-expand.34bc35648fa776c4b8f8ea2d179ee8c5.svg";